var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18075_4177",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18075_4177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0024 25.0827C12.4694 25.0827 11.0284 24.7918 9.67957 24.21C8.33071 23.6282 7.15744 22.8387 6.15974 21.8414C5.16205 20.8441 4.37212 19.6713 3.78995 18.323C3.20798 16.9747 2.91699 15.5342 2.91699 14.0014C2.91699 12.4684 3.20788 11.0275 3.78966 9.6786C4.37144 8.32974 5.16098 7.15646 6.15828 6.15877C7.15559 5.16107 8.32838 4.37114 9.67666 3.78897C11.0249 3.207 12.4655 2.91602 13.9983 2.91602C15.5313 2.91602 16.9722 3.2069 18.3211 3.78868C19.6699 4.37046 20.8432 5.16 21.8409 6.15731C22.8386 7.15461 23.6285 8.3274 24.2107 9.67568C24.7927 11.024 25.0837 12.4645 25.0837 13.9973C25.0837 15.5303 24.7928 16.9712 24.211 18.3201C23.6292 19.669 22.8397 20.8422 21.8424 21.8399C20.8451 22.8376 19.6723 23.6276 18.324 24.2097C16.9757 24.7917 15.5352 25.0827 14.0024 25.0827ZM14.9404 14.8743L13.3855 16.4292C13.2241 16.5908 13.1453 16.792 13.149 17.0327C13.1526 17.2734 13.2353 17.4746 13.3969 17.6361C13.5584 17.7977 13.7621 17.8785 14.0079 17.8785C14.2537 17.8785 14.4561 17.7977 14.6152 17.6361L17.5137 14.7376C17.7247 14.5266 17.8302 14.2805 17.8302 13.9993C17.8302 13.7182 17.7247 13.4721 17.5137 13.2611L14.6038 10.3512C14.4422 10.1898 14.241 10.1091 14.0003 10.1091C13.7596 10.1091 13.5584 10.1898 13.3969 10.3512C13.2353 10.5128 13.1545 10.7164 13.1545 10.9622C13.1545 11.208 13.2353 11.4104 13.3969 11.5695L14.9404 13.1243H10.5003C10.2524 13.1243 10.0446 13.2083 9.87703 13.3761C9.70923 13.5439 9.62533 13.7517 9.62533 13.9996C9.62533 14.2478 9.70923 14.4555 9.87703 14.6229C10.0446 14.7905 10.2524 14.8743 10.5003 14.8743H14.9404Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleRightArrow);
export default __webpack_public_path__ + "static/media/circle_right_arrow.d30afeb8d68f8471ed4ab80745605117.svg";
export { ForwardRef as ReactComponent };